<template>
    <div class="page-wrapper">
        <Header/>
        <div class="wrapper">
            <div class="page admin-page">
                <div class="container col2">
                    <div class="container-left">
                        <UserMenu/>
                    </div>

                    <div class="container-right">
                        <div class="page-title cabinet-page-title visibility">База клиентов</div>

                        <div class="admin-clients-search">
                            <label>
                                <input type="text" placeholder="Введите имя или email"
                                       @keyup.enter="loadUsers"
                                       v-model="nameOrEmailFilter">
                            </label>
                            <button class="button blue-button"
                                    @click="loadUsers">Найти
                            </button>
                        </div>

                        <div class="admin-clients-filter">
                            <div class="filter-checkbox">
                                <label><input type="checkbox" :value="tariff.TRIAL"
                                              v-model="tariffFilter"><span>Пробный</span></label>
                                <label><input type="checkbox" :value="tariff.STANDARD"
                                              v-model="tariffFilter"><span>Базовый</span></label>
                                <label><input type="checkbox" :value="tariff.PRO"
                                              v-model="tariffFilter"><span>PRO</span></label>
                            </div>
                            <button class="small-button small-button-f blue-button"
                                    @click="loadUsers">Применить фильтр
                            </button>
                        </div>

                        <div class="admin-clients-list">
                            <div class="table-wrapper">
                                <table>
                                    <tr>
                                        <th>№</th>
                                        <th>Имя</th>
                                        <th>Email</th>
                                        <th>Тариф</th>
                                        <th>Период действия</th>
                                        <th>Промокод</th>
                                    </tr>
                                    <tr v-for="(user, index) in users">
                                        <td>{{ pageSize * currentPage + index + 1 }}</td>
                                        <td>{{ user.name }}</td>
                                        <td>{{ user.email }}</td>
                                        <td>{{ formatTariff(user.tariff) }}</td>
                                        <td>{{ formatPeriod(user.subStartDate, user.subEndDate) }}</td>
                                        <td>{{ user.promocode }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <pagination
                                :currentPage="currentPage"
                                :totalPages="totalPages"
                                @load-page="loadUsers"/>
                    </div>
                </div>

            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import constants from '@/constants';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import UserMenu from '@/components/UserMenu';
    import Pagination from '@/components/Pagination';
    import moment from 'moment';

    export default {
        name: "SuperUserList",

        components: {
            Header, Footer, UserMenu, Pagination
        },

        data() {
            return {
                nameOrEmailFilter: null,
                tariffFilter: [
                    constants.tariff.TRIAL,
                    constants.tariff.STANDARD,
                    constants.tariff.PRO
                ],

                users: [],
                currentPage: 0,
                totalPages: 0,
                pageSize: 1,
            }
        },

        computed: {
            tariff() {
                return constants.tariff;
            }
        },

        async created() {
            let page = this.$route.query.page || 0;
            await this.loadUsers(page);
        },

        methods: {
            async loadUsers(page) {
                let payload = {
                    nameOrEmail: this.nameOrEmailFilter,
                    tariff: this.tariffFilter,
                    page: Number(page) || 0,
                    size: 50
                };

                let usersPage = await this.$store.dispatch('getClientsBase', payload);
                if (!usersPage)
                    return;

                this.users = usersPage.content;
                this.currentPage = usersPage.pageable.pageNumber;
                this.totalPages = usersPage.totalPages;
                this.pageSize = usersPage.pageable.pageSize;
            },

            formatTariff(tariff) {
                return constants.tariffNames.get(tariff) || 'Бесплатный';
            },

            formatPeriod(startDate, endDate) {
                if (!startDate || !endDate)
                    return '';
                return moment(startDate).format("DD.MM.YYYY")
                        + ' - ' + moment(endDate).format("DD.MM.YYYY");
            },
        }
    }
</script>